import { ResourceService } from "../common/common.services";
import { kioskState } from "../../base.routes";
import moment from "moment";

const KIOSK_STORAGE_KEY = "kiosk_id";
const KIOSK_ACTIVITY_KEY = "kiosk_last_activity";
const KIOSK_INACTIVITY_MS = 5 * 60 * 1000;
const INACTIVITY_CHECK_INTERVAL_MS = 1000;
const ACTIVITY_STORAGE_INTERVAL_MS = 1000;
const ACTIVITY_EVENTS = [
    "pointerdown",
    "pointermove",
    "keydown",
    "touchstart",
    "wheel",
    "scroll",
];

export class KioskService extends ResourceService {
    /* @ngInject */
    constructor(
        Restangular,
        $q,
        $http,
        localStorageService,
        $window,
        $document,
        $interval,
        $state,
    ) {
        super(Restangular, $q, "kiosks");
        this.$http = $http;
        this.localStorageService = localStorageService;
        this.$window = $window;
        this.$document = $document;
        this.$interval = $interval;
        this.$state = $state;
        this.endpoint = process.env.API_DOMAIN + "/api/kiosks";
        this.deviceRequestConfig = {
            skipAuthorization: true,
            withCredentials: true,
        };
        this.Restangular.extendModel(this.resource, function (model) {
            model.getPairingCode = function () {
                return this.customPOST({}, "pairing_code");
            };
            return model;
        });
    }

    pair(code) {
        let ctrl = this;
        return ctrl.$http
            .post(ctrl.endpoint + "/pair", { code }, ctrl.deviceRequestConfig)
            .then(function (response) {
                ctrl.rememberKiosk(response.data);
                return response.data;
            });
    }

    pairedDevice(kioskId) {
        let ctrl = this;
        return ctrl.$http
            .get(
                ctrl.endpoint + "/" + kioskId + "/paired_device",
                ctrl.deviceRequestConfig,
            )
            .then(function (response) {
                return response.data;
            });
    }

    scan(kioskId, value) {
        let ctrl = this;
        return ctrl.$http
            .post(
                ctrl.endpoint + "/" + kioskId + "/login",
                { value },
                ctrl.deviceRequestConfig,
            )
            .then(function (response) {
                return response.data;
            });
    }

    rememberKiosk(kiosk) {
        let ctrl = this;
        ctrl.localStorageService.set(KIOSK_STORAGE_KEY, kiosk.sid);
    }

    getKioskId() {
        let ctrl = this;
        return ctrl.localStorageService.get(KIOSK_STORAGE_KEY);
    }

    isKioskPage() {
        let ctrl = this;
        return ctrl.$window.location.pathname.startsWith("/kiosk/");
    }

    returnToKiosk() {
        let ctrl = this;
        return ctrl.$state.go(
            kioskState,
            { kiosk_sid: ctrl.getKioskId() },
            { location: "replace" },
        );
    }

    startInactivityLogout(onIdle) {
        let ctrl = this;
        if (!ctrl.getKioskId()) {
            return true;
        }
        let previousActivity = Number(
            ctrl.$window.sessionStorage.getItem(KIOSK_ACTIVITY_KEY),
        );
        ctrl.stopInactivityLogout();
        ctrl.lastActivityAt = previousActivity || moment.now();
        if (moment.now() - ctrl.lastActivityAt >= KIOSK_INACTIVITY_MS) {
            return false;
        }
        ctrl.onIdle = onIdle;
        ctrl.lastStoredActivityAt = ctrl.lastActivityAt;
        ctrl.$window.sessionStorage.setItem(
            KIOSK_ACTIVITY_KEY,
            ctrl.lastActivityAt,
        );
        ctrl.activityListener = function () {
            ctrl.recordActivity();
        };
        ctrl.wakeListener = function () {
            ctrl.checkInactivity();
        };
        ACTIVITY_EVENTS.forEach(function (event) {
            ctrl.$document[0].addEventListener(event, ctrl.activityListener, {
                passive: true,
                capture: true,
            });
        });
        ctrl.$document[0].addEventListener(
            "visibilitychange",
            ctrl.wakeListener,
        );
        ctrl.$window.addEventListener("focus", ctrl.wakeListener);
        ctrl.inactivityTimer = ctrl.$interval(
            function () {
                ctrl.checkInactivity();
            },
            INACTIVITY_CHECK_INTERVAL_MS,
            0,
            false,
        );
        return true;
    }

    recordActivity() {
        let ctrl = this;
        if (!ctrl.checkInactivity()) {
            return;
        }
        ctrl.lastActivityAt = moment.now();
        if (
            ctrl.lastActivityAt - ctrl.lastStoredActivityAt >=
            ACTIVITY_STORAGE_INTERVAL_MS
        ) {
            ctrl.$window.sessionStorage.setItem(
                KIOSK_ACTIVITY_KEY,
                ctrl.lastActivityAt,
            );
            ctrl.lastStoredActivityAt = ctrl.lastActivityAt;
        }
    }

    checkInactivity() {
        let ctrl = this;
        if (!ctrl.onIdle) {
            return false;
        }
        if (moment.now() - ctrl.lastActivityAt >= KIOSK_INACTIVITY_MS) {
            let onIdle = ctrl.onIdle;
            ctrl.stopInactivityLogout();
            onIdle();
            return false;
        }
        return true;
    }

    stopInactivityLogout() {
        let ctrl = this;
        ctrl.$interval.cancel(ctrl.inactivityTimer);
        if (ctrl.activityListener) {
            ACTIVITY_EVENTS.forEach(function (event) {
                ctrl.$document[0].removeEventListener(
                    event,
                    ctrl.activityListener,
                    true,
                );
            });
            ctrl.$document[0].removeEventListener(
                "visibilitychange",
                ctrl.wakeListener,
            );
            ctrl.$window.removeEventListener("focus", ctrl.wakeListener);
        }
        ctrl.onIdle = null;
        ctrl.inactivityTimer = null;
        ctrl.$window.sessionStorage.removeItem(KIOSK_ACTIVITY_KEY);
    }
}
